import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

export interface FunnelPreviewResponse {
  token: string;
  preview_text: string;
  media_type: string | null;
  media_metadata: {
    owner?: string | null;
    likes?: number | null;
    caption?: string | null;
    thumbnail?: string | null;
  };
  expires_at: string | null;
}

export interface FunnelClaimResponse {
  inspiration: {
    id: string;
    project_id: string;
    url: string;
    audio_transcription: string;
  };
  url: string;
  audio_transcription: string;
}

/** POST /funnel/transcribe-preview — público (sem auth), rate limited por IP. */
export const useFunnelPreview = () => {
  return useMutation({
    mutationFn: async (url: string): Promise<FunnelPreviewResponse> => {
      const { data } = await axiosClient.post<FunnelPreviewResponse>(
        '/funnel/transcribe-preview',
        { url }
      );
      return data;
    },
  });
};

/** POST /funnel/claim/{token} — requer auth + assinatura ativa. */
export const useFunnelClaim = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (token: string): Promise<FunnelClaimResponse> => {
      const { data } = await axiosClient.post<FunnelClaimResponse>(
        `/funnel/claim/${token}`
      );
      return data;
    },
    onSuccess: () => {
      // Invalida a lista de inspirações para a nova transcrição aparecer
      void queryClient.invalidateQueries({ queryKey: ['inspirations'] });
    },
  });
};
